import React from 'react';
import { Grid, Header2Text } from '../../../../../ui-toolkit';
import { generateCheckDepositTableColumns } from './generateCheckDepositTableColumns';
import { ICheckDepositData } from '../../../../../types/order/escrow/ICheckDeposit';
import { StyledDisbursedContainer } from '../../shared/StyledDisbursedContainer';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

interface ICheckDepositsContainerProps {
  order: IOrderDetailsData;
  checkDeposits: ICheckDepositData[];
}

export const CheckDepositsContainer: React.FC<ICheckDepositsContainerProps> = ({ order, checkDeposits }) => {
  const checkDepositColumns: IBootstrapTableColumnProps<any>[] = generateCheckDepositTableColumns({ order });
  return (
    <Grid>
      <Header2Text>Check Deposits</Header2Text>
      <StyledDisbursedContainer
        defaultSorted={[{ dataField: 'updatedAt', order: 'desc' }]}
        columns={checkDepositColumns}
        keyField={'id'}
        data={checkDeposits}
      />
    </Grid>
  );
};
